export default __webpack_public_path__ + "static/media/Email.0c60cde1.png";